import Button from 'components/ui/Button';
import Layout from 'components/ui/Layout';
import { H3Css } from 'components/ui/Typography';
import styled from 'styled-components';
import { deviceMediumMax, deviceSmallMax } from 'theme/mediaQueries';
import { spacing1x, spacing2x, spacing4x } from 'theme/spacings';

export const SectionHeaderLayout = styled(Layout)`
	@media (max-width: ${deviceSmallMax}) {
		${H3Css};
		margin: ${spacing1x} 0;
	}
`;

export const SectionHeaderWrapper = styled.div`
	@media (max-width: ${deviceMediumMax}) {
		max-width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
`;

export const ContentButton = styled(Button)`
	position: absolute;
	margin: 0;
	padding: ${spacing1x} ${spacing2x} ${spacing1x} ${spacing1x};
	bottom: ${`-${spacing4x}`};
	@media (max-width: ${deviceSmallMax}) {
		position: static;
		margin-top: ${spacing1x};
	}
	& > svg {
		margin-bottom: 0.1rem;
	}
`;
